import React, { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import p5 from "p5";
import sketch from "../code/sketch";

export default function BackgroundSketch({ invert = false }) {
  const containerRef = useRef();
  const location = useLocation();
  const isNamesPage = location.pathname === "/collections";

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    let p5Instance;

    // --- Helper to create a sketch instance ---
    const createSketch = () => {
      p5Instance = new p5((p) => sketch(p, { invert }), container);

      // If it's the menu overlay version, don't animate
      if (container.closest(".menu-overlay")) {
        p5Instance.noLoop();
      }
    };

    // --- If this is a menu background, always create a new local sketch ---
    if (container.closest(".menu-overlay")) {
      createSketch();

      // Handle menu background refresh event
      const handleMenuRefresh = () => {
        if (container.closest(".menu-overlay")) {
          p5Instance.remove();
          createSketch();
        }
      };
      window.addEventListener("menuBackgroundRefresh", handleMenuRefresh);

      return () => {
        window.removeEventListener("menuBackgroundRefresh", handleMenuRefresh);
        p5Instance.remove();
      };
    }

    // --- Otherwise, this is the global background ---
    if (window.__p5Instance) {
      p5Instance = window.__p5Instance;
    } else {
      p5Instance = new p5((p) => {
        sketch(p, { invert });
        const originalSetup = p.setup?.bind(p);
        p.setup = () => {
          if (originalSetup) originalSetup();
          setTimeout(() => {
            window.__p5Ready = true;
            window.dispatchEvent(new Event("p5Ready"));
          }, 100);
        };
      }, container);
      window.__p5Instance = p5Instance;
    }

    const handleNamesExit = () => p5Instance.noLoop();
    window.addEventListener("namesExitStart", handleNamesExit);

    // --- Control animation depending on route ---
    if (isNamesPage) {
      p5Instance.loop();
    } else {
      p5Instance.noLoop();
    }

    return () => {
      window.removeEventListener("namesExitStart", handleNamesExit);
      if (!document.body.contains(container)) {
        p5Instance.remove();
        window.__p5Instance = null;
      }
    };
  }, [isNamesPage, invert]);

  return <div ref={containerRef} className="fixed-background" />;
}